module.exports = __webpack_public_path__ + "img/c01_unitfishingboat_Normal_ua.01b24bf5.webp";